export default __webpack_public_path__ + "assets/icon-name.8692e795.webp";